import React, { Component } from 'react'
import { Form, Input, Button, message } from 'antd'
import { gql, compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { loginUser } from '../../auth'

const FormItem = Form.Item

const currentUser = gql`
  query currentUser {
    currentUser {
      _id
      email
      profile {
        firstName
        lastName
        birthDate
        gender
      }
    }
  }
`
function hasErrors (fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field])
}

class LoginForm extends Component {
  state = {
    loginLoading: false,
    email: '',
    password: '',
    disabled: true
  }

  checkPassword = (rule, value, callback) => {
    if (value) {
      if (value.length > 7) {
        callback()
      } else {
        callback('Your password too short!')
      }
    }
  }

  handleResetPassword = () => {
    this.props.history.push('/password/reset')
    this.props.onClose()
  }

  handleLogin = e => {
    e.preventDefault()
    const { validateFields } = this.props.form
    validateFields((err, values) => {
      // console.log('values', values)
      // console.log(err)
      if (!err) {
        this.setState({
          loginLoading: true
        })
        loginUser(values).then(res => {
          if (res.error) {
            this.setState({
              loginLoading: false
            })
            return message.error(res.error.message, 10)
          }
          // console.log('login response', res)
          this.props.client
            .query({
              query: currentUser,
              fetchPolicy: 'network-only'
            })
            .then(data => {
              this.setState(
                {
                  loginLoading: false
                  // visible: false
                },
                this.props.onClose
              )
              // console.log('state', this.props.location.state)
              const { from } = this.props.location.state || {
                from: { path: '/dashboard' }
              }
              this.props.history.push(from)
              this.props.form.resetFields()
            })
          /*
            this.props.client.writeQuery({
                query: currentUser,
                data: {
                currentUser: res.data
                }
            })
            console.log('read', this.props.client.readQuery({
                query: currentUser
            }))
            // .then(data => {
                // console.log('login', data)
            this.props.history.push('/dashboard')
            // })
    */
        })
      }
    })
  }

  render = () => {
    const {
      getFieldDecorator,
      getFieldsError,
      getFieldError,
      isFieldTouched,
      isFieldsTouched
    } = this.props.form
    const email = isFieldTouched('email') && getFieldError('email')
    // const password = isFieldTouched('password') && getFieldError('password')
    return <Form onSubmit={this.handleLogin}>
        <div className="lineLoginTitle">
          <span className="loginModalTitle">OR</span>
        </div>
        <div className="loginTextField">
          <FormItem validateStatus={email ? 'error' : ''} help={email || ''} hasFeedback>
            {getFieldDecorator('email', {
              initialValue: '',
              rules: [
                {
                  type: 'string',
                  message: 'The input is not valid E-mail!',
                  // eslint-disable-next-line no-useless-escape
                  pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                },
                {
                  required: true,
                  message: 'Please input your E-mail!'
                }
              ]
            })(<Input placeholder="Email" />)}
          </FormItem>
        </div>
        <div className="loginTextField">
          <FormItem hasFeedback>
            {getFieldDecorator('password', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: 'Please enter your password!'
                },
                {
                  validator: this.checkPassword
                }
              ]
            })(<Input type="password" placeholder="Password" />)}
          </FormItem>
        </div>
        <div className="loginTextField">
          <span>
            <a onClick={this.handleResetPassword}>Forgot Password</a>
          </span>
          <Button type="primary" htmlType="submit" size="large" loading={this.state.loginLoading} style={{ float: 'right' }} disabled={hasErrors(getFieldsError()) || !isFieldsTouched(
                ['email']
              )}>
            Log In
          </Button>
        </div>
      </Form>
  }
}

export default compose(
  Form.create(),
  withApollo,
  withRouter // TODO: should put router only inside auth wrapper
)(LoginForm)



// WEBPACK FOOTER //
// ./src/common/AuthModal/LoginForm.js